module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAASFJREFUWEftl7FKA0EQhr8RO1sfIAGLtPYWsbX0CUw95BlinkHuLA2+hGVS+BBCBO8B7CwDO7K5y2o4MMea3EHY7faYmf/fj9sZVuh4SdB/tB6OYdgbA4TzvfgzPhHeQi1HwVgWfl8ayOwOeNqLWNMijmtvojsDMEJlVjegsvnmiXgyBSr9pgfbisvsA+gBM1RGFW2rYo7RQG45jluEK1TeaZ1AZhu8ikrehYEVcAp0ZmAJXOC4YSwv7RN4tjO+uETltfrjj+UWCEVUH7DQ2qP6wAS4jxKuJ0UYKIfTBFl3svhlLFCZhgI/V3VHJ4yX/DszGUgEEoFEIBFIBHYSONQQqtf9NQ0fbMgJ8/a0ga2nmVcuTfxv9jc9Qe1x2jTxAHHfV9YwMOMWPR8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/img/deviceSave.png
// module id = 9pU4
// module chunks = 1